export { default } from './NewsStatusButton';
